/**
 * @generated SignedSource<<51e9be6951402febe5f5c12f6055b529>>
 * @relayHash ba730152b9374465138d1016a2bff2b8
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ba730152b9374465138d1016a2bff2b8

import { ConcreteRequest } from 'relay-runtime';
export type DocumentType = "AUDIO" | "PDF" | "PHOTO" | "VIDEO";
export type FileUploadStatus = "ERROR" | "HYPERLINK_PROCESSING_FAILED" | "JAVA_SCRIPT_PROCESSING_FAILED" | "MALICIOUS" | "NO_THREAT_FOUND" | "SCAN_TIMEOUT" | "UPLOADED";
export type MedicalReportType = "MEDICAL_REPORT" | "OTHER";
export type De_uploadMedicalReportFilesInput = {
  files: ReadonlyArray<any>;
  progressNoteId: string;
  reportType: MedicalReportType;
};
export type deMedicalReportUploadMutation$variables = {
  addConnections: ReadonlyArray<string>;
  input: De_uploadMedicalReportFilesInput;
};
export type deMedicalReportUploadMutation$data = {
  readonly uploadMedicalReportFiles: {
    readonly uploadMedicalReportFilesOutput: {
      readonly attachments?: ReadonlyArray<{
        readonly attachmentType: DocumentType;
        readonly createdAt: string;
        readonly fileName: string;
        readonly id: string;
        readonly progressNoteId: string;
        readonly reportType: MedicalReportType;
        readonly sessionId: string;
        readonly uploadStatus: FileUploadStatus | null;
        readonly url: string;
      }>;
      readonly error?: {
        readonly fileName: string | null;
        readonly message: string;
      };
      readonly isSuccess?: boolean;
    } | null;
  };
};
export type deMedicalReportUploadMutation = {
  response: deMedicalReportUploadMutation$data;
  variables: deMedicalReportUploadMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "addConnections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fileName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "MedicalReportAttachment",
  "kind": "LinkedField",
  "name": "attachments",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "attachmentType",
      "storageKey": null
    },
    (v3/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uploadStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "progressNoteId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "reportType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sessionId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSuccess",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UploadMedicalReportFilesError",
      "kind": "LinkedField",
      "name": "error",
      "plural": false,
      "selections": [
        (v3/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "message",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ErrorUploadMedicalReportFilesOutput",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "deMedicalReportUploadMutation",
    "selections": [
      {
        "alias": "uploadMedicalReportFiles",
        "args": (v2/*:: as any*/),
        "concreteType": "De_uploadMedicalReportFilesPayload",
        "kind": "LinkedField",
        "name": "de_uploadMedicalReportFiles",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "uploadMedicalReportFilesOutput",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  (v4/*:: as any*/)
                ],
                "type": "SuccessUploadMedicalReportFilesOutput",
                "abstractKey": null
              },
              (v5/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "deMedicalReportUploadMutation",
    "selections": [
      {
        "alias": "uploadMedicalReportFiles",
        "args": (v2/*:: as any*/),
        "concreteType": "De_uploadMedicalReportFilesPayload",
        "kind": "LinkedField",
        "name": "de_uploadMedicalReportFiles",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "uploadMedicalReportFilesOutput",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v4/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "filters": null,
                    "handle": "appendNode",
                    "key": "",
                    "kind": "LinkedHandle",
                    "name": "attachments",
                    "handleArgs": [
                      {
                        "kind": "Variable",
                        "name": "connections",
                        "variableName": "addConnections"
                      },
                      {
                        "kind": "Literal",
                        "name": "edgeTypeName",
                        "value": "de_ProgressNoteEdge"
                      }
                    ]
                  }
                ],
                "type": "SuccessUploadMedicalReportFilesOutput",
                "abstractKey": null
              },
              (v5/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "ba730152b9374465138d1016a2bff2b8",
    "metadata": {},
    "name": "deMedicalReportUploadMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "e0cded64a62719ad0ca6ed49c97d3c6f";

export default node;
